import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";

export default function ExportButton({ testId = "export-button", variant = "outline", size = "sm" }) {
  const [downloading, setDownloading] = useState(false);

  const handleExport = async () => {
    setDownloading(true);
    try {
      const res = await api.get("/export", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      const date = new Date().toISOString().slice(0, 10);
      a.download = `ATH1_Revenue_Tracker_${date}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Excel export downloaded");
    } catch {
      toast.error("Export failed. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button data-testid={testId} onClick={handleExport} variant={variant} size={size}
      disabled={downloading} className="rounded-lg">
      {downloading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
      <span className="hidden sm:inline ml-1.5">Export Excel</span>
    </Button>
  );
}
